import { ScopeType } from '@fluidframework/azure-service-utils/legacy';
import { executeBackendFunction, } from './NetlifyUtilities.js';
export async function getFluidContainerId() {
    const result = await executeBackendFunction('GetFluidContainerId');
    if (result) {
        return result.containerId;
    }
    else {
        return false;
    }
}
export async function getFluidTenantId() {
    const result = await executeBackendFunction('GetFluidTenantId');
    if (result) {
        return result.tenantId;
    }
    else {
        return false;
    }
}
export async function getAzureFluidRelayAccessToken(tenantId, fluidContainerId, userName, tokenLifetimeInSeconds) {
    const scopes = [ScopeType.DocRead, ScopeType.DocWrite, ScopeType.SummaryWrite];
    const queryParameters = [
        {
            name: 'userId',
            value: userName,
        },
        {
            name: 'userNickname',
            value: userName,
        },
        {
            name: 'tenantId',
            value: tenantId,
        },
        {
            name: 'tokenLifetimeInSeconds',
            value: tokenLifetimeInSeconds,
        },
        {
            name: 'scopes',
            value: JSON.stringify(scopes),
        },
    ];
    if (fluidContainerId !== undefined) {
        queryParameters.push({
            name: 'fluidContainerId',
            value: fluidContainerId,
        });
    }
    const result = await executeBackendFunction('GetAzureFluidRelayAccessToken', queryParameters);
    if (result) {
        return result.token;
    }
    else {
        return false;
    }
}
//# sourceMappingURL=AzureFluidRelay.js.map